import request from '@/utils/request'

// 登录
export function loginCheck(data) {
    return request({
        url: '/loginCheck',
        method: 'post',
        data: data
    })
}

// 获取验证码
export function generateImage(params) {
    return request({
        url: '/generateImage',
        method: 'get',
        responseType: 'arraybuffer',
        params: params
    })
}

// 退出登录
export function logout() {
    return request({
        url: '/logout',
        method: 'get',
    })
}

// 修改密码
export function checkPassword(data) {
    return request({
        url: '/revisePwd/checkPassword',
        method: 'post',
        data: data
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js